import { GraphQLError } from 'graphql/index';

export const isNotNullish = <T>(x: T): x is NonNullable<T> => x !== null && x !== undefined;

export type Maybe<T> = T | null | undefined;

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends ReadonlyArray<infer U>
    ? ReadonlyArray<DeepPartial<U>>
    : T[P] extends Array<infer U>
    ? Array<DeepPartial<U>>
    : T[P] extends object
    ? DeepPartial<T[P]>
    : T[P];
};

export type DeepRequired<T> = {
  [P in keyof T]-?: T[P] extends ReadonlyArray<infer U>
    ? ReadonlyArray<DeepRequired<U>>
    : T[P] extends Array<infer U>
    ? Array<DeepRequired<U>>
    : T[P] extends object
    ? DeepRequired<T[P]>
    : T[P];
};

export type ErrorLike = string | { errors: GraphQLError[]; [key: string]: any } | Error;

export type PromiseLike<T> = Promise<T> | T;

export type ArrayLike<T> = T | T[];
